import { Button } from "@utp/react-components-prod";
import ImgSupport from "assets/img/role-not-support.svg";
import ImgSupportEpg from "assets/img/role-not-support-epg.svg";
import useLogout from "features/Logout/hooks/useLogout";
import useClientId from "hooks/useClientId";

export const RoleNotSupport = () => {
  const { logout } = useLogout();
  const { isClientIdEpg } = useClientId();
  return (
    <div
      className="w-full h-full flex flex-col justify-center items-center bg-white"
      style={{ minHeight: "100vh" }}
    >
      <div className="text-center">
        <img src={isClientIdEpg ? ImgSupportEpg : ImgSupport} alt="rol no soportado" className="m-auto mb-6" />
        <h1 className="text-neutral-03 text-heading-02 font-bold mb-5">
          Acceso no autorizado
        </h1>
        <p className="text-color-02 mb-6">
          Si necesitas ayuda o crees que es un error, comunícate con {isClientIdEpg
            ? " el equipo de UTP+class."
            : " tu asesor educativo."}
        </p>
        <Button
          text="Cerrar sesión"
          color="primary"
          // @ts-ignore
          dataTestId="btn-reload"
          onClick={() => logout()}
        />
      </div>
    </div>
  );
};
